import React, { useContext, useEffect, useState } from "react";
import "../../css_files/Ticket/Step1Ticket.css";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import getCookie from "../../api";
import { toast, ToastContainer } from "react-toastify";
import TicketDetail from "./TicketDetail";
import Swal from "sweetalert2";
import AutoCompleteSearch from "../Master/AutoCompleteSearch";
import axiosInstance from "../../api";
import TicketParts from "./TicketParts";
import { triggerscroll } from "../Homepage/Homepage";

function Step1Ticket({ setCatchStep, enquiryId, setTicketId, ticketId }) {
  setCatchStep(useLocation().pathname.split("/")[4].trim());
  const [newEnquiryData, setNewEnquiryData] = useState();
  const nav = useNavigate();
  const [showticketdetail, setshowticketdetail] = useState(false);
  const [partnames, setpartnames] = useState([]);
  const { userData, permissionsdata } = useContext(triggerscroll);

  const [ticketData, setTicketData] = useState({
    EnquiryId: "",
    Status: "Open",
    EnquirySeriesId: enquiryId,
    EnquiryType: "",
    ServiceDetails: {
      ServiceDescription: "",
      ServiceType: "Paid",
      DueDate: "",
      Remarks: "",
    },
    CompanyId: "",
  });

  const [partsTicketData, setPartsTicketData] = useState([]);
  const [partsTicketLoading, setPartsTicketLoading] = useState(false);
  const [showpartsTicketData, setShowPartsTicketData] = useState(false);
  const [collapseparts, setcollapseparts] = useState([]);
  const [extraParts, setExtraParts] = useState(false);
  const [extraPartsInput, setExtraPartsInput] = useState([]);
  const [createPartsTicket, setCreatePartsTicket] = useState([]);
  const [loading, setloading] = useState(false);

  function handleSubmit(e) {
    e.preventDefault();
    setloading(true);
    if (newEnquiryData?.enquiryType === "Parts") {
      axiosInstance
        .post(`${process.env.REACT_APP_API_URL}/api/v1/Ticket`, ticketData)
        .then((res) => {
          setTicketId(res.data.id);
          axiosInstance
            .post(
              `${process.env.REACT_APP_API_URL}/api/PartsTicket/AddPartTicket`,
              {
                BoilerHead: newEnquiryData.customerBoiler.boiler.head,
                boilerSeries:
                  newEnquiryData.customerBoiler.boilerSeriess.seriesCode,
                partIds: [...createPartsTicket, ...extraPartsInput],
                TicketId: res.data.id,
                EnquiryId: enquiryId,
                CompanyId: newEnquiryData.companyId,
              }
            )
            .then((resp) => {
              setloading(false);
              setShowPartsTicketData(false);
              Swal.fire({
                icon: "success",
                text: `Ticket Created Successfully with Id ${res.data.id}`,
                showConfirmButton: true,
                showCancelButton:
                  ticketData.ServiceDetails.ServiceType === "Paid",
                confirmButtonText: "Go To Tickets",
                cancelButtonText: "Go to Next Step",
                cancelButtonColor: "green",
                confirmButtonColor: "darkblue",
              }).then((x) => {
                if (x.isConfirmed) {
                  nav("/dashboard/tickets");
                } else {
                  nav("/dashboard/checkin/steps/step2");
                }
              });
            })
            .catch((err) => {
              setloading(false);
            });
        })
        .catch((err) => {
          setloading(false);
          toast.error(err?.response?.data ?? err?.message ?? "Failed", {
            position: "bottom-center",
            theme: "dark",
          });
        });
    } else {
      axiosInstance
        .post(`${process.env.REACT_APP_API_URL}/api/v1/Ticket`, ticketData)
        .then((res) => {
          setTicketId(res.data.id);
          setloading(false);
          Swal.fire({
            icon: "success",
            text: `Ticket Created Successfully with Id ${res.data.id}`,
            showConfirmButton: true,
            showCancelButton: ticketData.ServiceDetails.ServiceType === "Paid",
            confirmButtonText: "Go To Tickets",
            cancelButtonText: "Go to Next Step",
            cancelButtonColor: "green",
            confirmButtonColor: "darkblue",
          }).then((x) => {
            if (x.isConfirmed) nav("/dashboard/tickets");
            else nav("/dashboard/checkin/steps/step2");
          });
        })
        .catch((err) => {
          setloading(false);
          toast.error(err?.response?.data ?? err?.message ?? "Failed", {
            position: "bottom-center",
            theme: "dark",
          });
        });
    }
  }

  function writePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Operations" && x.subHead === "Ticket" && x.isWrite === true
    );
    return !issatisfied;
  }

  useEffect(() => {
    setNewEnquiryData(null);
    axiosInstance
      .get(
        `${
          process.env.REACT_APP_API_URL
        }/api/v1/NewEnquiry/GetEnquiryById?seriesId=${encodeURIComponent(
          enquiryId
        )}`
      )
      .then((res) => {
        setNewEnquiryData(res.data);
        setTicketData({
          ...ticketData,
          EnquiryId: res.data.id,
          EnquiryType: res.data.enquiryType,
          ServiceDetails: {
            ...ticketData.ServiceDetails,
            ServiceDescription: res.data.servicesLookingFor,
          },
          CompanyId: res.data.companyId,
        });
      })
      .catch(console.log);
  }, [enquiryId]);

  return (
    <>
      <section className="step1-ticket">
        {newEnquiryData && (
          <>
            <div className="step1-ticket-div">
              <h1>Company Information</h1>
              <blockquote id="step1TicketLinkedtoEnquiry">
                <h2>Linked to Enquiry: {newEnquiryData.seriesID}</h2>
                <p>
                  Originally Created On:{" "}
                  {new Date(newEnquiryData.dateOfEnquiry).toDateString()}
                </p>
              </blockquote>

              <blockquote>
                <p>
                  <strong>Company/Organization Name: </strong>
                  {newEnquiryData.customer.orgName}
                </p>
                <p>
                  <strong>Customer Name: </strong>
                  {newEnquiryData.contactCentre.salutation}{" "}
                  {newEnquiryData.contactCentre.name}
                </p>
                <p>
                  <strong>Customer Email: </strong>
                  {newEnquiryData.contactCentre.email}
                </p>
                <p>
                  <strong>Customer Phone Number: </strong>
                  {newEnquiryData.contactCentre.phoneNumber}
                </p>
                <p>
                  <strong>
                    {newEnquiryData.isAddressSame
                      ? "Ship To Address / Bill To Address"
                      : "Ship To Address"}
                    :{" "}
                  </strong>
                  {newEnquiryData.shipToAddress.addressType}:{" "}
                  {newEnquiryData.shipToAddress.officeName ||
                    newEnquiryData.shipToAddress.factoryName}
                  , {newEnquiryData.shipToAddress.address1},{" "}
                  {newEnquiryData.shipToAddress.address2},{" "}
                  {newEnquiryData.shipToAddress?.cityObj?.name ||
                    newEnquiryData.shipToAddress?.cityName}
                  ,{" "}
                  {newEnquiryData.shipToAddress?.stateObj?.name ||
                    newEnquiryData.shipToAddress?.stateName}
                  , {newEnquiryData.shipToAddress.country},{" "}
                  {newEnquiryData.shipToAddress.pincode}
                </p>
                {newEnquiryData.isAddressSame === false && (
                  <p>
                    <strong>Bill To Address: </strong>
                    {newEnquiryData.billToAddress.addressType}:{" "}
                    {newEnquiryData.billToAddress.officeName ||
                      newEnquiryData.billToAddress.factoryName}
                    , {newEnquiryData.billToAddress.address1},{" "}
                    {newEnquiryData.billToAddress.address2},{" "}
                    {newEnquiryData.billToAddress?.cityObj?.name ||
                      newEnquiryData.billToAddress?.cityName}
                    ,{" "}
                    {newEnquiryData.billToAddress?.stateObj?.name ||
                      newEnquiryData.billToAddress?.stateName}
                    , {newEnquiryData.billToAddress.country},{" "}
                    {newEnquiryData.billToAddress.pincode}`
                  </p>
                )}

                <p>
                  <strong>Customer Boiler: </strong>
                  {newEnquiryData.customerBoiler.boiler.head} |{" "}
                  {newEnquiryData.customerBoiler.boilerSeriess.seriesCode}
                </p>
                <p>
                  <strong>Enquiry Type: </strong>
                  {newEnquiryData.enquiryType}
                </p>
              </blockquote>
            </div>

            <form id="submitServiceDetailsForm" onSubmit={handleSubmit}>
              <h1>{newEnquiryData?.enquiryType} Details</h1>
              <blockquote>
                <label>
                  {newEnquiryData?.enquiryType} Description{" "}
                  <sup>
                    <i
                      class="fa-solid fa-asterisk"
                      style={{ color: "red" }}
                    ></i>
                  </sup>
                </label>
                <textarea
                  placeholder={`Enter ${newEnquiryData?.enquiryType} Description (Maximum 800 Characters)`}
                  rows={5}
                  onInput={(e) => {
                    e.target.value = e.target.value.slice(0, 800);
                  }}
                  onChange={(e) => {
                    setTicketData({
                      ...ticketData,
                      ServiceDetails: {
                        ...ticketData.ServiceDetails,
                        ServiceDescription: e.target.value,
                      },
                    });
                  }}
                  value={newEnquiryData.servicesLookingFor}
                  required
                ></textarea>
              </blockquote>
              <aside>
                <blockquote style={{ gap: "1rem" }}>
                  <label>
                    Service Type{" "}
                    <sup>
                      <i
                        class="fa-solid fa-asterisk"
                        style={{ color: "red" }}
                      ></i>
                    </sup>
                  </label>
                  <blockquote style={{ flexDirection: "row", gap: "2rem" }}>
                    <mark>
                      <input
                        type="radio"
                        name="serviceType"
                        value="Paid"
                        onChange={(e) => {
                          if (e.target.checked) {
                            setTicketData({
                              ...ticketData,
                              ServiceDetails: {
                                ...ticketData.ServiceDetails,
                                ServiceType: e.target.value,
                              },
                            });
                          }
                        }}
                        checked={
                          ticketData.ServiceDetails.ServiceType === "Paid"
                        }
                        required
                      />
                      <p>Paid</p>
                    </mark>
                    <mark>
                      <input
                        type="radio"
                        name="serviceType"
                        value="FOC"
                        onChange={(e) => {
                          if (e.target.checked) {
                            setTicketData({
                              ...ticketData,
                              ServiceDetails: {
                                ...ticketData.ServiceDetails,
                                ServiceType: e.target.value,
                              },
                            });
                          }
                        }}
                        required
                        checked={
                          ticketData.ServiceDetails.ServiceType === "FOC"
                        }
                      />
                      <p>FOC (Free of Cost)</p>
                    </mark>
                  </blockquote>
                </blockquote>
              </aside>
              <aside>
                <blockquote>
                  <label>
                    Due Date{" "}
                    <sup>
                      <i
                        class="fa-solid fa-asterisk"
                        style={{ color: "red" }}
                      ></i>
                    </sup>
                  </label>
                  <input
                    type="date"
                    required
                    onChange={(e) => {
                      setTicketData({
                        ...ticketData,
                        ServiceDetails: {
                          ...ticketData.ServiceDetails,
                          DueDate: e.target.value,
                        },
                      });
                    }}
                  />
                </blockquote>

                <blockquote>
                  {ticketData.ServiceDetails.ServiceType === "FOC" && (
                    <>
                      <label>
                        Remarks{" "}
                        <sup>
                          <i
                            class="fa-solid fa-asterisk"
                            style={{ color: "red" }}
                          ></i>
                        </sup>
                      </label>
                      <textarea
                        rows={2}
                        placeholder="Enter Remarks (Maximum 300 Characters)"
                        required
                        onInput={(e) => {
                          e.target.value = e.target.value.slice(0, 300);
                        }}
                        onChange={(e) =>
                          setTicketData({
                            ...ticketData,
                            ServiceDetails: {
                              ...ticketData.ServiceDetails,
                              Remarks: e.target.value,
                            },
                          })
                        }
                      ></textarea>
                    </>
                  )}
                </blockquote>
              </aside>
              {newEnquiryData?.enquiryType === "Parts" && (
                <a
                  href="#"
                  style={{ fontSize: "1.5rem" }}
                  onClick={() => {
                    setShowPartsTicketData(true);
                  }}
                >
                  Click Here to Manage Parts
                </a>
              )}
            </form>
          </>
        )}

        {showpartsTicketData && (
          <TicketParts
            newEnquiryData={newEnquiryData}
            partsTicketLoading={partsTicketLoading}
            partsTicketData={partsTicketData}
            collapseparts={collapseparts}
            setcollapseparts={setcollapseparts}
            extraParts={extraParts}
            extraPartsInput={extraPartsInput}
            setExtraPartsInput={setExtraPartsInput}
            setPartsTicketData={setPartsTicketData}
            setPartsTicketLoading={setPartsTicketLoading}
            setShowPartsTicketData={setShowPartsTicketData}
            setExtraParts={setExtraParts}
            setCreatePartsTicket={setCreatePartsTicket}
            createPartsTicket={createPartsTicket}
            partnames={partnames}
            setpartnames={setpartnames}
          />
        )}
        <div className="step1-ticket-div-last-child">
          <button onClick={() => nav("/dashboard/enquiries")}>Cancel</button>
          <button
            type={loading || writePermission() ? "button" : "submit"}
            style={{ opacity: writePermission() && 0.5 }}
            form="submitServiceDetailsForm"
          >
            {loading ? (
              <i class="fa-solid fa-circle-notch fa-spin fa-2x"></i>
            ) : (
              <p>
                {writePermission()
                  ? "You Do Not Have Permission To Create Ticket"
                  : "Create Ticket"}
              </p>
            )}
          </button>
        </div>
      </section>

      {showticketdetail && (
        <TicketDetail
          ticketId={ticketId}
          setTicketId={setTicketId}
          setshowticketdetail={setshowticketdetail}
          showticketdetail={showticketdetail}
        />
      )}
    </>
  );
}

export default Step1Ticket;
